import api from '../http.service';
import { API_ENDPOINTS } from '@/config/api.config';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterData {
  email: string;
  password: string;
  fullName: string;
  tenantId?: string;
}

export interface User {
  id: string;
  email: string;
  fullName: string;
  role: string;
  tenantId?: string;
  avatarUrl?: string;
  preferences?: Record<string, any>;
  menuAccess?: string[] | null;
  /** Agent role: assigned bot UUIDs; empty = all bots in tenant */
  agentBotIds?: string[];
  lastLogin?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface AuthResponse {
  user: User;
  accessToken: string;
  refreshToken: string;
  requirePasswordChange?: boolean;
}

// Login
export const login = async (credentials: LoginCredentials): Promise<AuthResponse> => {
  const response = await api.post(`${API_ENDPOINTS.STUDIO.AUTH}/login`, credentials);
  return response.data.data;
};

// Register
export const register = async (data: RegisterData): Promise<AuthResponse> => {
  const response = await api.post(`${API_ENDPOINTS.STUDIO.AUTH}/register`, data);
  return response.data.data;
};

// Get current user
export const getCurrentUser = async (): Promise<User> => {
  const response = await api.get(`${API_ENDPOINTS.STUDIO.AUTH}/me`);
  return response.data.data;
};

export const patchMyPreferences = async (
  partial: Record<string, unknown>
): Promise<{ preferences: Record<string, unknown> }> => {
  const response = await api.patch(`${API_ENDPOINTS.STUDIO.AUTH}/me/preferences`, partial);
  return response.data.data;
};

export const patchMyProfile = async (
  data: { fullName?: string; avatarUrl?: string }
): Promise<User> => {
  const response = await api.patch(`${API_ENDPOINTS.STUDIO.AUTH}/me/profile`, data);
  return response.data.data;
};

// Refresh token
export const refreshToken = async (refreshToken: string): Promise<{ accessToken: string }> => {
  const response = await api.post(`${API_ENDPOINTS.STUDIO.AUTH}/refresh-token`, {
    refreshToken,
  });
  return response.data.data;
};

// Logout
export const logout = async (): Promise<void> => {
  await api.post(`${API_ENDPOINTS.STUDIO.AUTH}/logout`);
};

export default {
  login,
  register,
  getCurrentUser,
  patchMyPreferences,
  patchMyProfile,
  refreshToken,
  logout,
};

